<mat-icon
  class="material-symbols-rounded fill b3n-background"
  [ngClass]="status"
  [class.online]="isOnline"
  [style.width.px]="width"
  [style.height.px]="width"
  [style.fontSize.px]="width"
  >{{ iconName }}
</mat-icon>
